<template>
  <button
    v-if="tippy_content"
    class="outline-none focus:outline-none btnIcon flex-shrink-0 flex items-center justify-center s:h-10 s:w-10 h-7 w-7 rounded-full"
    :class="[color, weight, style]"
    id="button-icon"
    :data-tippy-content="tippy_content"
  >
    <slot />
  </button>
  <button
    class="outline-none focus:outline-none btnIcon flex-shrink-0 flex items-center justify-center s:h-10 s:w-10 h-7 w-7 rounded-full"
    :class="[color, weight, style]"
    v-else
  >
    <slot />
  </button>
</template>

<script>
import { computed } from "vue";
import tippy from "tippy.js";
export default {
  name: "button-icon",
  props: {
    color: String,
    style: String,
    tippy_content: String,
    fontWeight: {
      type: String,
      default: "normal",
      validator: value => {
        return [
          "hairline",
          "thin",
          "light",
          "medium",
          "semibold",
          "bold",
          "extrabold",
          "black",
          "normal"
        ].includes(value);
      }
    }
  },
  setup(props) {
    const weight = computed(() => `font-${props.fontWeight}`);

    tippy("#button-icon");

    return { weight };
  }
};
</script>

<style lang="scss" scoped>
.btnIcon {
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
}
</style>
